import React from 'react'

import { Grid, RadioContainer, RadioWrapper, TitleBox } from '../auditorium.style'

interface MiddleColumnSelectorProps {
    columns: number
    selectedMiddleColumn: number | undefined
}

const MiddleColumnDisplay: React.FC<MiddleColumnSelectorProps> = ({ columns, selectedMiddleColumn }) => {
    return (
        <RadioContainer>
            <TitleBox>Középvonal</TitleBox>
            <Grid rows={1} columns={columns - 1}>
                {Array.from({ length: columns - 1 }).map((_, columnIndex) => (
                    <RadioWrapper key={columnIndex}>
                        <input
                            type="radio"
                            value={columnIndex + 1}
                            checked={selectedMiddleColumn === columnIndex + 1}
                            onChange={() => {}}
                            disabled={true}
                        />
                    </RadioWrapper>
                ))}
            </Grid>
            <TitleBox>Nézőtér</TitleBox>
        </RadioContainer>
    )
}

export default MiddleColumnDisplay
